import React, { useEffect, useState } from 'react'
import { HorizontalLoader } from 'Components'
import { BoostCreditFunnel } from 'BoostXpressAdmin/Model/boostCreditXModel'
import { formatString } from 'Helpers/formatString'
import { handleError } from 'Helpers' 
import { boostCreditBXService } from 'BoostXpressAdmin/Services/boostCreditBXService'

const formatCurrency = (amount: number) => `₦${amount.toLocaleString()}`

interface FunnelOverviewProps {
  totalDrawdown: number
}

const FunnelOverview: React.FC<FunnelOverviewProps> = ({ totalDrawdown }) => {
  const [funnel, setFunnel] = useState<BoostCreditFunnel | null>(null)
  const [funnelLoading, setFunnelLoading] = useState(false)

  useEffect(() => {
    let cancelled = false

    const loadFunnel = async () => {
      try {
        setFunnelLoading(true)
        const response = await boostCreditBXService.getFunnel()
        if (cancelled) return
 
        setFunnel(response.data.data ?? null)
      } catch (error) {
        if (cancelled) {
          setFunnel(null)
          handleError(error as any)
        }
      } finally {
        if (!cancelled) setFunnelLoading(false)
      }
    }

    loadFunnel()

    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div className='bx-boost-credit__funnel'>
      {/* <h4 className='bx-boost-credit__funnel-title'>Boost Flex Funnel Overview</h4> */}
      {funnelLoading ? (
        <div className='row g-3'>
          <div className='col-12'>
            <div className='card border-0 bg-white'>
              <div className='card-body d-flex justify-content-center'>
                <HorizontalLoader />
              </div>
            </div>
          </div>
        </div>
      ) : funnel ? (
        <>
          <div className='row g-3'>
            <div className='col-12 col-md-6 col-lg-3'>
              <div className='card border-0 funnel-card-total'>
                <div className='card-body'>
                  <small className='text-uppercase fw-bold funnel-card-label'>Total Users</small>
                  <div className='display-6 fw-bold funnel-card-value'>{funnel.totalCount}</div>
                </div>
              </div>
            </div>
            {funnel.stages?.map((stage, index) => (
              <div key={index} className='col-12 col-md-6 col-lg-3'>
                <div className='card border-0 funnel-card shadow-sm'>
                  <div className='card-body'>
                    <small className='text-uppercase fw-bold funnel-card-label'>{formatString(stage.stage)}</small>
                    <div className='display-6 fw-bold funnel-card-value'>{stage.count}</div>
                    <small className='funnel-card-percentage'>
                      {((stage.count / funnel.totalCount) * 100).toFixed(1)}%
                    </small>
                  </div>
                </div>
              </div>
            ))}



              <div className='col-12 col-md-6 col-lg-3'>
                <div className='card border-0 funnel-card shadow-sm'>
                    <div className='card-body'>
                      <small className='text-uppercase fw-bold funnel-card-label'>Total Flex</small>
                      <div className='h5 fw-bold funnel-criteria-item-value'>
                        {totalDrawdown} 
                      </div>
                      <small className='funnel-card-percentage'>
                      All drawdown
                      </small>
                    </div>
                  </div>
                </div>
          </div>

           <h6 className='funnel-criteria-title mt-4 mb-2 fs-6 fw-bold'>Eligibility Criteria</h6>
           
            <div className='row g-3'>
              <div className='col-12 col-md-6 col-lg-3'>
                <div className='card border-0 funnel-card shadow-sm'>
                    <div className='card-body'>
                      <small className='text-uppercase fw-bold funnel-card-label'>Cumulative Threshold</small>
                      <div className='h5 fw-bold funnel-criteria-item-value'>
                        {formatCurrency(funnel.criteria.unlockCumulativeThresholdMajor)}
                      </div>
                    </div>
                  </div>
                </div>
              <div className='col-12 col-md-6 col-lg-3'>
                <div className='card border-0 funnel-card shadow-sm'>
                    <div className='card-body'>
                      <small className='text-uppercase fw-bold funnel-card-label'>Min Orders</small>
                      <div className='h5 fw-bold funnel-criteria-item-value'>
                        {funnel.criteria.eligibilityMinOrders}
                      </div>
                    </div>
                  </div>
                </div>
              <div className='col-12 col-md-6 col-lg-3'>
                <div className='card border-0 funnel-card shadow-sm'>
                    <div className='card-body'>
                      <small className='text-uppercase fw-bold funnel-card-label'>Window Days</small>
                      <div className='h5 fw-bold funnel-criteria-item-value'>
                        {funnel.criteria.eligibilityWindowDays} days
                      </div>
                    </div>
                  </div>
                </div>
              <div className='col-12 col-md-6 col-lg-3'>
                <div className='card border-0 funnel-card shadow-sm'>
                    <div className='card-body'>
                      <small className='text-uppercase fw-bold funnel-card-label'>Min Account Age</small>
                      <div className='h5 fw-bold funnel-criteria-item-value'>
                        {funnel.criteria.eligibilityMinAccountAgeDays} days
                      </div>
                    </div>
                  </div>
                </div>
              
              </div> 
        </>
      ) : (
        <div className='row g-3'>
          <div className='col-12'>
            <div className='card border-0 bg-white'>
              <div className='card-body'>
                <small className='text-uppercase fw-bold funnel-card-label'>Failed to load funnel</small>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default FunnelOverview
